
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import Intro from './components/intro/intro';
import Steps from '../../components/steps/steps';
import Loading from '../../components/loading/loading';
import OrderForm from './components/order-form/order-form';
import OrderForm2 from './components/order-form/order-form2';
import TermsAndCon from './components/terms-and-con/terms-and-con';
import OrderSummary from './components/order-summary/order-summary';
import OrderComplete from './components/order-complete/order-complete';
import SessionExpired from './components/session-expired/session-expired';
import BrowserIncompatible from './../../components/browser-incompatible/browser-incompatible';
import Investment  from './components/investment-detail/investment-detail';

import Order from '../../models/order';
import styles from './invest.module.scss';
import UserService from '../../services/user-service';

import { authenticatePublicSession, getSessionId } from '../../helpr/authHelper';
import likeIcon from '../../assets/like.svg';
import moneyIcon from '../../assets/money.svg';
import receiptIcon from '../../assets/receipt.svg';
import handshakeIcon from '../../assets/handshake.svg';
import orderFormIcon from '../../assets/orderform.svg';
import likeActiveIcon from '../../assets/like-active.svg';
import moneyActiveIcon from '../../assets/money-active.svg';
import receiptActiveIcon from '../../assets/receipt-active.svg';
import orderFormActiveIcon from '../../assets/orderform-active.svg';
import handshakeActiveIcon from '../../assets/handshake-active.svg';

import Session from '../../models/session';

import GenericErrorModal from '../../components/generic-error-modal/generic-error-modal';

const Invest = () => {


  // Page States
  const LOADING              =   0;
  const SESSION_EXPIRED      =   1;
  const INTRO                =   2;
  const INVESTMENT           =   3;
  const BROWSER_INCOMPATIBLE =   4;

  const location = useLocation()

  const userService = new UserService();
  const queryParams = new URLSearchParams(window.location.search);
  const [ session , setSession ] = useState({});
  const [ pageState, setPageState ] = useState(LOADING);
  const [ activeTabIndex, setActiveTabIndex ] = useState(0);
  const [ orderInfo, setOrderInfo ] = useState();

  // Amount of purchase for a particular security
  const [ purchaseAmount, setAmount ] = useState(null);

  const [ errorModalShow, setErrorModalShow ] = useState(false);


  useEffect(()=>{
    /*
      Validate Session On Load
    */
    if( queryParams.has('session') ){
      try {
        authenticatePublicSession(queryParams.get('session'));
        getUserSession(getSessionId());
      }
      catch(error) {
        setPageState(BROWSER_INCOMPATIBLE);
      }
    } else {
      setPageState(SESSION_EXPIRED);
    }
  },[])

  const scrollTop = () =>{
    window.scrollTo({top: 0});
  };

  const setPurchaseAmount = (amount) => {
    setAmount(amount);
    setOrderInfo(prev=>({...prev, purchaseAmount: amount}));
  }

  /*
    Save order formstaste Page 1
  */
  const saveOrderFormState = (formState) => {
    const { primaryContactLastname, primaryContactFirstname, primaryContactMiddlename } = formState;
    let accountNames = '';
    let primaryContactPersonName = '';

    /*
      Build Segmented Primary Contact Person Name
    */
    if( primaryContactLastname ) {
      primaryContactPersonName = [
        primaryContactLastname + ',',
        primaryContactFirstname,
        primaryContactMiddlename
      ].join(' ');
    }

    if( formState['investorCategory'] === 'INDV'){
      formState['applicantNames'].map((data, index)=>{
        accountNames += data['last_name'] + ', ' + data['first_name'] + ' ' + data['middle_name'];
        if(index !== formState['applicantNames'].length-1 && formState['applicantNames'].length>1){
          accountNames += ' ' + formState['applicantAssoc'] + ' ';
        }
      })
    } else {
      accountNames = formState['primaryApplicant'];
    }

    const applInfo = formState['applicantNames'][0];
    let primaryApplicant = formState['primaryApplicant'];
    let primaryApplicantBirthDate = formState['dateOfBirthOrIncorporation'];
    if( formState['investorCategory'] === 'INDV' ) {
      primaryApplicant = applInfo['last_name'] + ', ' + applInfo['first_name'] + ' ' + applInfo['middle_name'];
      primaryApplicantBirthDate = applInfo['date_of_birth'];
    }

    setOrderInfo(prev=>({
      ...prev,
      securityId: session['securityId'],
      investorCategory: formState['investorCategory'].split('-')[0].trim(),
      primaryApplicant: primaryApplicant,
      primaryContactPersonName: primaryContactPersonName,
      accountNames: accountNames,
      applicantList: {
        applicants: formState['applicantNames'],
        assoc: formState['applicantAssoc'] !== null ? formState['applicantAssoc'] : ''
      },
      primaryContactPerson: {
        lastName: formState['primaryContactLastname'],
        firstName: formState['primaryContactFirstname'],
        middleName: formState['primaryContactMiddlename'],
        relation: formState['primaryContactRelation']
      },
      purchaseAmount: parseFloat(purchaseAmount),
      nationality: formState['nationality'],
      dateOfBirthOrIncorporation: primaryApplicantBirthDate,
      placeOfBirthOrIncorporation: formState['placeOfBirthOrIncorporation'],
      idType: formState['idType'],
      idNumber: formState['idNumber'],
      taxStatus: formState['taxStatus'],
      businessDetails: {
        parentCompany: formState['parentCompany'],
        name: formState['nameOfEmployerOrBusiness'],
        nature: formState['natureOfWorkOrPrincipalBusiness'],
        sourcesOfIncome: formState['sourcesOfIncome']
      }
    }))
  }

  const saveOrderFormState2 = (formState) => {
    const { addressStreetAddress, addressDistrictOrTown, addressCity, addressStateProvinceRegion, addressCountry, addressZipcode } = formState;
    const { presentAddressStreet, presentAddressDistrictTown, presentAddressCity, presentAddressStateProvinceRegion, presentAddressCountry, presentAddressZipCode } = formState;

    let mailingAddress = [
      addressStreetAddress,
      addressDistrictOrTown,
      addressCity,
      addressStateProvinceRegion,
      addressCountry
    ].join(' ');

    let presentMailingAddress = [
      presentAddressStreet,
      presentAddressDistrictTown,
      presentAddressCity,
      presentAddressStateProvinceRegion,
      presentAddressCountry
    ].join(' ');

    setOrderInfo(prev=>({
      ...prev,
      contactNumbers: {
        telephoneNumbers: formState['contactTelephoneNumbers'],
        faxNumbers: formState['contactFaxNumbers']
      },
      modeOfCollectionOfInterest: formState['modeOfCollectionOfInterest'],
      modeOfPayment: {
        option: formState['modeOfPaymentOption'],
        bank: formState['modeOfPaymentBank'],
        checkNumber: formState['modeOfPaymentCheckNumber'],
        debitAccountNumber: formState['modeOfPaymentDebitAccountNumber']
      },
      bankPesoAccountNumber: formState['bankPesoAccountNumber'],
      settBankCode: formState['settBankCode'],
      statementDeliveryMode: formState['statementDeliveryMode'],
      place: formState['place'],
      address: {
        streetAddress: addressStreetAddress,
        districtOrTown: addressDistrictOrTown,
        city: addressCity,
        stateProvinceRegion: addressStateProvinceRegion,
        country: addressCountry,
        zipCode: addressZipcode
      },
      presentAddress: {
        streetAddress: presentAddressStreet,
        districtOrTown: presentAddressDistrictTown,
        city: presentAddressCity,
        stateProvinceRegion: presentAddressStateProvinceRegion,
        country: presentAddressCountry,
        zipCode: presentAddressZipCode
      },
      mailingAddress: mailingAddress,
      presentMailingAddress: presentMailingAddress,
      securityRegistration: formState['securityRegistration'],
      pdtcDepositoryParticipantName: formState['pdtcDepositoryParticipantName'],
      applicantNoCDBPID: formState['applicantNoCDBPID'],
      pdtcDepositoryParticipantBPID: formState['pdtcDepositoryParticipantBPID'],
      pdtcDepositoryParticipantOmnibusAccNo: formState['pdtcDepositoryParticipantOmnibusAccNo']
    }))
  }

  /*
    Get User Session Data
  */
  const getUserSession = async (sessionId) => {
    try {
      const result = await userService.getUserSession(sessionId);
      const session = result['session'];
      setSession( new Session(session) );
      setOrderInfo(new Order({investorEmail: session['investorEmail']}));
      setPageState(INTRO);
    } catch(error) {
      const status = error?.response?.status ?? error?.statusCode;
      if(status === 403 || status === 401){
        setPageState(SESSION_EXPIRED);
      } else {
        setPageState(SESSION_EXPIRED);
        setErrorModalShow(true);
      }
    }
  }

  /*
    Proceed to next step or back 1 step
  */
  const nextStep = (back=false) => {
    if( back && activeTabIndex > 0 ){
      setActiveTabIndex( activeTabIndex - 1 );
      scrollTop();
    } else if( activeTabIndex <= keys.length ){
      setActiveTabIndex(activeTabIndex + 1);
      scrollTop();
    }
  }

  // Page Keys
  const keys = [
    {
      id: 'investmentDetail',
      name: 'RESERVATION DETAIL',
      component: <Investment session={session} purchaseAmount={purchaseAmount} setPurchaseAmount={setPurchaseAmount} nextStep={nextStep}/>,
      logo: { active: moneyActiveIcon, inactive: moneyIcon }
    },
    {
      id: 'orderForm',
      name: 'RESERVATION FORM',
      component: <OrderForm session={session} orderInfo={orderInfo} saveOrderFormState={saveOrderFormState} purchaseAmount={purchaseAmount} nextStep={nextStep}/>,
      logo: { active: orderFormActiveIcon, inactive: orderFormIcon }
    },
    {
      id: 'orderForm',
      name: 'RESERVATION FORM',
      component: <OrderForm2 session={session} orderInfo={orderInfo} saveOrderFormState={saveOrderFormState2} purchaseAmount={purchaseAmount} nextStep={nextStep}/>,
      logo: { active: orderFormActiveIcon, inactive: orderFormIcon }
    },
    {
      id: 'termsAndCon',
      name: 'TERMS AND CONDITIONS',
      component: <TermsAndCon setOrderInfo={setOrderInfo} nextStep={nextStep}/>,
      logo: { active: handshakeActiveIcon, inactive: handshakeIcon }
    },
    {
      id: 'orderSummary',
      name: 'RESERVATION SUMMARY',
      component: <OrderSummary session={session} orderInfo={orderInfo} nextStep={nextStep} setPageState={setPageState} setErrorModalShow={setErrorModalShow}/>,
      logo: { active: receiptActiveIcon, inactive: receiptIcon }
    },
    {
      id: 'orderComplete',
      name: 'RESERVATION COMPLETE',
      logo: { active: likeActiveIcon, inactive: likeIcon },
      component: <OrderComplete session={session}/>
    }
  ]

  /*
    Render Investment Forms
  */
  const investButtonAction = () => { setPageState(INVESTMENT); }
  const renderPages = () => {
    switch( pageState ){
      case LOADING: return <div className={styles['loading']}><Loading/></div>;
      case SESSION_EXPIRED: return <SessionExpired/>;
      case BROWSER_INCOMPATIBLE: return <BrowserIncompatible/>;
      case INTRO: return <Intro investButtonAction={investButtonAction} session={session}/>;
      case INVESTMENT: {
        return (
          <>
            <Steps activeKeyIndex={activeTabIndex} keys={keys}/>
            { keys[activeTabIndex].component }
          </>
        )
      };
    }
  }

  return (
    <>
      <Container className={styles['invest-component']}>
        { renderPages() }
      </Container>
      <GenericErrorModal show={errorModalShow} setShow={setErrorModalShow}/>
    </>
  )
}

export default Invest;



